/* eslint semi:0 */
import BaseClass from '../../application/BaseClass'
import { empty, make } from '../../utils/component'
import { getIsDesktop } from '../../utils/ua'
import UserToolbarView from '../views/UserToolbarView'
import UserToolbarVm from '../vms/userToolbarVm'
import userStore from '../stores/userStore'
import { external } from '../../utils/script'
import { fbSdkReady } from '../actions/userToolbarActions'

class UserToolbarController extends BaseClass {
  constructor(options = {}) {
    super()
    let store = options.store || userStore
    this.vm = UserToolbarVm.create({ store })
    if (!this.vm.store.isAuthenticated) {
      let facebookSdk = external.load({ name: 'facebook' })
      facebookSdk(fbSdkReady)
    }
  }
}

let component = getIsDesktop() ? make(UserToolbarController, UserToolbarView) : empty
export default component



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/components/userToolbarComponent.js